import React, { useState, useEffect } from 'react';
import { useTexts } from './data';
import tracker from './analytics/tracker';

function CountdownScreen() {
  const TEXTS = useTexts();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    tracker.pageViewCountdown();
  }, []);

  useEffect(() => {
    const updateCountdown = () => {
      const launchDate = new Date(TEXTS.LAUNCH_DATE).getTime();
      const now = new Date().getTime();
      const distance = launchDate - now;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [TEXTS]);

  return (
    <div
      className="d-flex align-items-center justify-content-center px-3"
      style={{
        minHeight: '100dvh',
        background:
          'linear-gradient(135deg, #1a0000 0%, #4a0e0e 50%, #2d0a0a 100%)',
      }}
    >
      <div className="text-center" style={{ maxWidth: '420px' }}>
        <div style={{ fontSize: '2rem' }}>🪔</div>
        <h6
          className="fw-bold mb-0"
          style={{ color: '#f5c842', fontFamily: 'serif' }}
        >
          {TEXTS.TEMPLE_NAME}
        </h6>
        <small style={{ color: '#e8b830', fontSize: '0.7rem' }}>
          {TEXTS.TEMPLE_SUBTITLE}
        </small>
        <p className="mb-3" style={{ color: '#d4a528', fontSize: '0.7rem' }}>
          📍 {TEXTS.TEMPLE_LOCATION}
        </p>

        <div
          className="p-3 rounded-3 mb-3"
          style={{
            background: 'rgba(245, 200, 66, 0.1)',
            border: '1px solid rgba(245, 200, 66, 0.3)',
          }}
        >
          <h5 className="fw-bold mb-1" style={{ color: '#f5c842' }}>
            {TEXTS.COUNTDOWN_TITLE}
          </h5>
          <small style={{ color: '#e0c68a' }}>{TEXTS.COUNTDOWN_SUBTITLE}</small>
        </div>

        <div className="d-flex flex-nowrap justify-content-center mb-4 gap-2">
          {[
            { value: timeLeft.days, label: TEXTS.COUNTDOWN_DAYS },
            { value: timeLeft.hours, label: TEXTS.COUNTDOWN_HOURS },
            { value: timeLeft.minutes, label: TEXTS.COUNTDOWN_MINUTES },
            { value: timeLeft.seconds, label: TEXTS.COUNTDOWN_SECONDS },
          ].map((item) => (
            <div
              key={item.label}
              className="text-center p-2 rounded-3"
              style={{
                background: 'rgba(245, 200, 66, 0.1)',
                border: '1px solid rgba(245, 200, 66, 0.2)',
                minWidth: '60px',
              }}
            >
              <div
                className="fw-bold"
                style={{ color: '#f5c842', fontSize: '1.5rem' }}
              >
                {item.value}
              </div>
              <small style={{ color: '#d4a528', fontSize: '0.65rem' }}>
                {item.label}
              </small>
            </div>
          ))}
        </div>

        <small className="fw-bold d-block mb-2" style={{ color: '#e8b830' }}>
          {TEXTS.COUNTDOWN_PREVIOUS_YEAR_TITLE}
        </small>
        <a
          href="https://kondarangihills.com/app/2025"
          className="btn btn-sm fw-bold"
          target="_blank"
          rel="noreferrer"
          onClick={() => tracker.archiveClick(2025)}
          style={{
            background: 'linear-gradient(135deg, #f5c842, #d4a528)',
            color: '#1a0000',
            border: 'none',
          }}
        >
          {TEXTS.COUNTDOWN_CLICK_HERE}
        </a>
      </div>
    </div>
  );
}

export default CountdownScreen;
